import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GrainOverlay from "@/components/GrainOverlay";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import CinderArchive from "@/components/CinderArchive";
import BookPremise from "@/components/BookPremise";
import AboutCreator from "@/components/AboutCreator";
import CoverStatus from "@/components/CoverStatus";
import ProfessionalInquiries from "@/components/ProfessionalInquiries";
import SiteFooter from "@/components/SiteFooter";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import Terms from "@/pages/Terms";

const Landing = () => {
  return (
    <div className="App relative">
      <GrainOverlay />
      <Nav />
      <main>
        <Hero />
        <CinderArchive />
        <BookPremise />
        <AboutCreator />
        <CoverStatus />
        <ProfessionalInquiries />
      </main>
      <SiteFooter />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
